'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hexToComponents = require('./hexToComponents');

var _hexToComponents2 = _interopRequireDefault(_hexToComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexToRgb = function hexToRgb(hex) {
  var asStr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var rgb = (0, _hexToComponents2.default)(hex);

  rgb = rgb ? {
    r: parseInt(rgb[0], 16),
    g: parseInt(rgb[1], 16),
    b: parseInt(rgb[2], 16)
  } : {
    r: 0,
    g: 0,
    b: 0
  };

  if (asStr) {
    var _rgb = rgb,
        _r = _rgb.r,
        _g = _rgb.g,
        _b = _rgb.b;

    return 'rgb(' + _r + ', ' + _g + ', ' + _b + ')';
  }

  return rgb;
};

exports.default = hexToRgb;


//////////////////
// WEBPACK FOOTER
// ./node_modules/color-invert/lib/hexToRgb.js
// module id = 72
// module chunks = 0